import React from "react";
import {Table, Button, Alert} from 'react-bootstrap';

import ModalPopup from './../Modal/Modal.js'


const ReactPayPal = (props)=> {
  const paypalRef = React.useRef();
  // payment completion modal
  const [showRecipt, setShowRecipt]    = React.useState(false);
  const [reciptModal, setReciptModal]  = React.useState({
                                                          title: '',  
                                                          body: '',  
                                                          actions: '',  
                                                        });


  const createReciptModal = React.useCallback ((status, data) => {
      const modalContent = {
                            title: '',  
                            body: '',  
                            actions: '',  
                          }
      const closeButton = <Button onClick={()=>setShowRecipt(false)} variant="secondary" >Close</Button>;

      // If the payment has been made
      if (status === 'approved') {
        const {id, payer, create_time, purchase_units } = data;
        // item info
        const {amount, description, shipping} = purchase_units[0];
        // customer info
        const {email_address, name} = payer;
        // modal content
        const body = (
          <Table>
            <tbody>
              <tr><td>Order ID</td><td>{`: ${id}`}</td></tr>
              <tr><td>Order Date</td><td>{`: ${create_time}`}</td></tr>
              
              <tr><td>Order Amount</td><td>{`: ${amount.value} ${amount.currency_code}`}</td></tr>
              <tr><td>Item Description</td><td>{`: ${description}`}</td></tr>


              <tr><td>Customer Name</td><td>{`: ${name.given_name} ${name.surname}`}</td></tr>
              <tr><td>Customer E-mail</td><td>{`: ${email_address}`}</td></tr>
              <tr>
                  <td>Shipping Address</td>
                  <td>
                    {`: ${shipping.name.full_name}`}<br/>
                    {`  ${shipping.address.address_line_1}`}<br/>
                    {`  ${shipping.address.currency_code} ${shipping.address.postal_code} `}<br/>
                  </td>
              </tr>
            </tbody>
          </Table>
        );
        modalContent.title = `Your order recieved. Thank you!`;
        modalContent.body = body;
        modalContent.actions = (
            <React.Fragment>
              <Button onClick={()=> window.print()}>Print</Button>
              {closeButton}
            </React.Fragment>
          );

      }
      // If user canceled
      else if( status === 'cancel') {
        const body = (
            <Alert variant="info">
              You have canceled the order and your order did NOT go through. Please try again.
            </Alert>
        );
        modalContent.title = `Order ${data.orderID} canceled`;
        modalContent.body = body;
        modalContent.actions = closeButton;
      }
      // If any error occurs
      else if( status === 'error') {
        const body = (
            <Alert variant="danger">
              <strong>Error! {data.message}.</strong><br/>
              Your order did NOT go through. Please try again.<br/>
              If the problem persists, please contact us.
            </Alert>
        );
        modalContent.title = `Error occurred`;
        modalContent.body = body;
        modalContent.actions = closeButton;
      }
      setShowRecipt(true);
      setReciptModal({...modalContent});
  },[]);

  // To show PayPal buttons once the component loads
  const {price, description} = props;
  React.useEffect(() => {
    window.paypal
      .Buttons({
        createOrder: (data, actions) => {
          return actions.order.create({
            intent: "CAPTURE",
            purchase_units: [
              {
                description: description,
                amount: {
                  currency_code: "USD",
                  value: price.toFixed(2),
                },
              },
            ],
          });
        },
        onApprove: async (data, actions) => {
          const order = await actions.order.capture();
          createReciptModal('approved', order);
        
        },
          // error
        onError: (err) => {
          createReciptModal('error', err);
        },
          // user cancel return
        onCancel: function (data) {
          createReciptModal('cancel', data)
        },

      })
      .render(paypalRef.current);
      
  }, [price, description, createReciptModal]);
  

  // Default Render
  return (
    <React.Fragment>
      <div ref={paypalRef} />
      <ModalPopup   show={showRecipt} 
                    onHide={() => setShowRecipt(false)} 
                    modaltitle={reciptModal.title}
                    modalbody= {reciptModal.body}
                    modalactions= {reciptModal.actions}
                  />
    </React.Fragment>
  );
  
}

export default ReactPayPal;